import { Suspense, lazy } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Route, Routes } from 'react-router-dom';

import { routePathConfig } from 'src/routes/config';
import { ClientParamsGuard } from 'src/routes/guards/ClientParamsGuard';
import Login from 'src/features/login/pages';
import Landing from 'src/features/landing/pages';
import ErrorPage from 'src/features/error/pages';
import { pittaTheme } from 'src/themes/muiTheme';

const GrantConsent = lazy(() => import('src/features/grantConsent/pages'));

const RouteFallback = () => (
  <Box
    sx={{
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress />
  </Box>
);

const App = () => (
  <MuiThemeProvider theme={pittaTheme}>
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path={routePathConfig.landing} element={<Landing />} />
        <Route element={<ClientParamsGuard />}>
          <Route path={routePathConfig.login} element={<Login />} />
          <Route path={routePathConfig.grantConsent} element={<GrantConsent />} />
        </Route>
        <Route path={routePathConfig.error} element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  </MuiThemeProvider>
);

export default App;
